// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/code-ofac-flights/list',
    name: 'code-ofac-flights-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/CodeOFAC.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_code_ofac_flights',
    },
  },
]

export default formTable
